import { AlertCircleIcon, CheckCircle2Icon } from 'lucide-react'

import { cn } from '@/lib/utils'

import { NoSubscription } from './no-subscription/no-subscription'
import { UploadDocumentFileInput } from './upload-document-file-input/upload-document-file-input'
import { useUploadDocumentContent } from './use-upload-document-content'

export const UploadDocumentContent = () => {
  const { isAdmin, isFreeTrialAvailable, hasSubscription, handleSelectDocumentFiles } = useUploadDocumentContent()

  return (
    <div>
      <div className={cn('flex flex-col gap-y-2')}>
        <h3 className={cn('text-lg font-semibold text-black')}>Upload your file</h3>
        <p className={cn('text-base font-normal text-[#1e1e1e]')}>
          You can upload either a single document or multiple documents—up to <b>20MB</b> in total at a time.
        </p>
        <p className={cn('flex items-center gap-x-2.5', 'text-slate-500')}>
          <AlertCircleIcon size={20} />
          <span className={cn('text-xs font-medium')}>
            Please make sure to verify the auto-filled data after uploading the scanned file.
          </span>
        </p>
      </div>

      <div className={cn('my-[30px]')}>
        {hasSubscription && <UploadDocumentFileInput onSelect={handleSelectDocumentFiles} />}
        {!hasSubscription && <NoSubscription isAdmin={isAdmin} isFreeTrialAvailable={isFreeTrialAvailable} />}
      </div>

      <div>
        <p className={cn('text-base font-bold text-black', 'mb-5')}>
          Upload your documents — our system will take care of the rest!
        </p>
        <InfoTexts
          texts={[
            'Automatically extracts key details like case numbers, filing dates, and more — minimizing manual entry time.',
            'Identifies important dates such as approval, expiration, RFE, etc for automatic notification setup.',
            'Instantly view results after upload.',
          ]}
        />
      </div>
    </div>
  )
}

const InfoTexts = ({ texts }: { texts: string[] }) => {
  return (
    <ul className={cn('flex flex-col gap-y-4', 'list-none')}>
      {texts.map((text, index) => (
        <li key={index} className={cn('text-sm font-normal text-black')}>
          <p className={cn('flex items-center gap-x-2.5')}>
            <CheckCircle2Icon size={24} className={cn('text-green-500')} />
            <span>{text}</span>
          </p>
        </li>
      ))}
    </ul>
  )
}
